import {
    apiRequest,
    orangtuaDetail
} from "../../../../../../services/adapters/kepegawaian/orangtuaService"

class DetailRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", orangtuaDetail, {
            params: query
        }, true)
    }
}

export default DetailRepository